import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { IsiComponent } from './isi/isi.component';
import { MatDialogModule } from '@angular/material/dialog';
import { InViewportModule } from '@thisissoon/angular-inviewport';

@NgModule({
  declarations: [FooterComponent, IsiComponent],
  imports: [CommonModule, RouterModule, MatDialogModule, InViewportModule],
  exports: [FooterComponent, IsiComponent]
})
export class FooterModule {}
